export enum RecipientAction {
    Edit = 1,
    ToolBox = 2,
    PairedDonors = 3
}